"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT_TYPE = exports.SSR_TYPE = exports.IMAGE_TYPE = void 0;
var TRANSLATION = {
  baggageTitle: 'Baggage',
  baggageTileDescription: 'Pre-book for the lowest price. Prices shown are for all flights in your trip.',
  mealTitle: 'Meal',
  mealTileDescription: 'Pre-book for the lowest price. Prices shown are for all flights in your trip.',
  seatTitle: 'Seat',
  seatTileDescription: 'Pre-book for the lowest price. Prices shown are for all flights in your trip.'
};
exports.TRANSLATION = TRANSLATION;
var TEXT_TYPE = {
  normal: {
    type: 'textNormal',
    color: 'neutral'
  },
  small: {
    type: 'small',
    color: 'greyDark'
  },
  large: {
    type: 'textLarge',
    color: 'neutral'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var SSR_TYPE = {
  BAGGAGE: 'baggage',
  MEAL: 'meal',
  SEAT: 'seat'
};
exports.SSR_TYPE = SSR_TYPE;
var IMAGE_TYPE = {
  baggage: {
    tileLogo: {
      height: '80px',
      width: '80px',
      src: 'https://a.staticaa.com/images/misc/baggage.svg'
    }
  },
  meal: {
    tileLogo: {
      height: '80px',
      width: '80px',
      src: 'https://a.staticaa.com/images/misc/meal.svg'
    }
  },
  seat: {
    tileLogo: {
      height: '80px',
      width: '80px',
      src: 'https://a.staticaa.com/images/misc/seat.svg'
    }
  }
};
exports.IMAGE_TYPE = IMAGE_TYPE;